import { createRouter, createWebHistory } from 'vue-router'
import { resolveCurrentUserId } from '@/assets/js/utils'

const routes = [
  { path: '/desktop', name: 'home', component: () => import('../views/HomeView.vue') },
  { path: '/SoftwareCenter', name: 'SoftwareCenter', component: () => import('../views/SoftwareCenter.vue') },
  { path: '/ConversionTool', name: 'ConversionTool', component: () => import('../views/ConversionTool.vue') },
  { path: '/FeedbackView', name: 'FeedbackView', component: () => import('../views/FeedbackView.vue') },
  { path: '/DownloadManager', name: 'DownloadManager', component: () => import('../views/DownloadManager.vue') },
  { path: '/MapTool', name: 'MapTool', component: () => import('../views/download/MapTool.vue') },
  { path: '/TerrainTool', name: 'TerrainTool', component: () => import('../views/download/TerrainTool.vue') },
  { path: '/Aerscreen', name: 'AerscreenView', component: () => import('../views/AerscreenView.vue') },
  { path: '/MessageManger', name: 'MessageManger', component: () => import('../views/MessageManger.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/desktop' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫：统一收敛 userId 解析入口，保证页面进入时 query 与当前会话状态同步
router.beforeEach((to) => {
  resolveCurrentUserId(to.query.userId)
  return true
})

export default router
